import React from 'react';
import { withRouter } from 'react-router-dom';
import { SubMenu, SubOption } from './MenuStyles';
import Transition from 'react-transition-group/Transition';

class SubMenuComponent extends React.Component {
  state = {
    hovered: null
  };

  OnOptionHover = option => {
    this.setState({ hovered: option });
  };

  render() {
    const { show, onMouseEnter, onMouseLeave, navigate } = this.props;
    const { hovered } = this.state;
    return (
      <Transition
        timeout={{ enter: 0, exit: 100 }}
        in={show}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <SubMenu
            state={state}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <SubOption
              onClick={() => navigate('/about')}
              active={hovered == null || hovered === 'who'}
              onMouseEnter={() => this.OnOptionHover('who')}
              onMouseLeave={() =>
                this.setState({ hovered: null, openSub: false })
              }
            >
              Who we are
            </SubOption>
            <SubOption
              onClick={() => navigate('/members')}
              active={hovered == null || hovered === 'members'}
              onMouseEnter={() => this.OnOptionHover('members')}
              onMouseLeave={() =>
                this.setState({ hovered: null, openSub: false })
              }
            >
              Members
            </SubOption>
            <SubOption
              onClick={() => navigate('/management')}
              active={hovered == null || hovered === 'management'}
              onMouseEnter={() => this.OnOptionHover('management')}
              onMouseLeave={() =>
                this.setState({ hovered: null, openSub: false })
              }
            >
              Management
            </SubOption>
          </SubMenu>
        )}
      </Transition>
    );
  }
}

export default withRouter(SubMenuComponent);



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenuComponent.js